import {FC} from "react";

export const Toggle: FC<{value: boolean, onChange: (newValue: boolean) => void, label?: string, size?: 'sm'|'md'}> = props => {
  const size = props.size ?? 'md'
  if (props.label) {
    return <label className={`flex items-center ${size == 'md' ? 'h-16 border border-gray-100 px-4' : 'h-10 border-2 bg-white border-gray-200 px-3'} rounded-xs cursor-pointer max-w-md`}>
      <ToggleSwitch size={size} value={props.value} onChange={props.onChange} />
      <span className={`ml-3 ${size === 'md' ? '' : 'text-sm'}`}>{props.label}</span>
    </label>
  }
  return <ToggleSwitch size={size} value={props.value} onChange={props.onChange} />
}

const ToggleSwitch: FC<{value: boolean, onChange: (newValue: boolean) => void, size?: 'sm'|'md'}> = props => {
  const size = props.size ?? 'md'
  return <div className={`block rounded-full ${size === 'md' ? 'w-12 h-6' : 'w-10 h-5'} ${props.value ? 'bg-blue-800 ' : 'bg-slate-200 '} transition-colors relative`}>
    {/* Invisible input */}
    <input type="checkbox" checked={props.value} onChange={(e) => props.onChange(e.target.checked)} className={"hidden"}/>
    {/* Ball */}
    <div className={`${size === 'md' ? 'h-6 w-6' : 'h-5 w-5'} border bg-white rounded-full absolute transition-all top-0 ${props.value ? `${size === 'md' ? 'left-6' : 'left-5'} border-blue-800` : 'left-0 border-slate-200'}`}></div>
  </div>
}